import { useEffect, useState } from 'react';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { isUserTimezoneDifferent } from '../../utils/date-helpers';
import { useSchedulingLocationInfo } from '../use-scheduling-location-info';

export const useTimezoneBanner = () => {
  const [showTimezoneBanner, setShowTimezoneBanner] = useState(false);
  const { accessibleLocationData } = useSchedulingLocationInfo();

  const dismissTimezoneBanner = () => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TIMEZONE_BANNER_DISMISSED, 'true');
    setShowTimezoneBanner(false);
  };

  useEffect(() => {
    const isDismissed = localStorage.getItem(LOCAL_STORAGE_KEYS.TIMEZONE_BANNER_DISMISSED);

    if (isDismissed !== 'true') {
      const officeLocationTimezones = Object.values(accessibleLocationData).map((location) => location.timezone || '');
      setShowTimezoneBanner(isUserTimezoneDifferent(officeLocationTimezones));
    }
  }, [accessibleLocationData]);

  return {
    showTimezoneBanner,
    dismissTimezoneBanner,
  };
};
